<div class="row">
  <h4 (click)="collapseRecapturedDepreciation.toggle()"
      [attr.aria-expanded]="!isSectionRecapturedDepreciationCollapsed"
      aria-controls="recapturedDepreciation">
    Recaptured Depreciation
  </h4>

  <div #collapseRecapturedDepreciation="ngbCollapse" [(ngbCollapse)]="isSectionRecapturedDepreciationCollapsed">
    <div class="card table-result-card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="table-result table-result-row table-result-row-indent-0">
              <app-output-variable [selectedBadge]="selectedBadge"
                                   [style]="'primary'" [text]="'FNACC D'"
                                   class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
              <div class="table-result-col table-result-col-description">
                FNACC début
              </div>
              <div class="table-result-col table-result-col-dots"></div>
              <div class="table-result-col table-result-col-value">{{ propertyTransferredOptions.underpreciatedCapitalCostAfterAdditionsAndDispositions | currencyCents | notAvailable }}</div>
            </div>

            <div class="table-result table-result-row table-result-row-indent-0">
              <app-output-variable [selectedBadge]="selectedBadge"
                                   [style]="'primary'" [text]="'RÉDUC'"
                                   class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
              <div class="table-result-col table-result-col-description">
                FNACC réduction, le moindre de:
              </div>
            </div>


            <div class="table-result table-result-row table-result-row-indent-1">
              <app-output-variable [selectedBadge]="selectedBadge"
                                   [style]="'secondary'" [text]="'PD'"
                                   class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
              <div class="table-result-col table-result-col-description">Produit de disposition</div>
              <div class="table-result-col table-result-col-dots"></div>
              <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.agreedAmountForDepreciableProperty | currencyCents | notAvailable }}</div>
            </div>


            <div class="table-result table-result-row table-result-row-indent-1">
              <app-output-variable [selectedBadge]="selectedBadge"
                                   [style]="'secondary'" [text]="'CC'"
                                   class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
              <div class="table-result-col table-result-col-description">
                Coût en capital
              </div>
              <div class="table-result-col table-result-col-dots"></div>
              <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.adjustedCostBaseForDepreciableProperty | currencyCents | notAvailable }}</div>
            </div>

            <div class="table-result table-result-row table-result-row-align-indent-0 table-result-row-calculation">
              <div class="table-result-col table-result-col-description text-end">
                <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                     [text]="'RÉDUC'"></app-output-variable>
                = MIN(
                <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                                     [text]="'PD'"></app-output-variable>
                ,
                <app-output-variable [selectedBadge]="selectedBadge" [style]="'secondary'"
                                     [text]="'CC'"></app-output-variable>
                ) =
                MIN({{ propertyTransferredResults.agreedAmountForDepreciableProperty | currencyCents | notAvailable }}
                , {{ propertyTransferredResults.adjustedCostBaseForDepreciableProperty | currencyCents | notAvailable }}
                ) =
              </div>

              <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.fNACCReduction | currencyCents | notAvailable }}</div>
            </div>

            <div class="table-result table-result-row table-result-row-indent-0">
              <app-output-variable [selectedBadge]="selectedBadge"
                                   [style]="'primary'" [text]="'FNACC F'"
                                   class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
              <div class="table-result-col table-result-col-description">
                FNACC fin
              </div>
              <div class="table-result-col table-result-col-dots"></div>
              <div class="table-result-col table-result-col-description text-end">
                <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                     [text]="'FNACC D'"></app-output-variable>
                -
                <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                     [text]="'RÉDUC'"></app-output-variable>
                =
                {{ propertyTransferredOptions.underpreciatedCapitalCostAfterAdditionsAndDispositions | currencyCents | notAvailable }}
                -
                {{ propertyTransferredResults.fNACCReduction | currencyCents | notAvailable }}
                =
              </div>
              <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.underpreciatedCapitalCostAfterAdditionsAndDispositions | currencyCents | notAvailable }}</div>
            </div>

            <div class="table-result table-result-row table-result-row-indent-0">
              <app-output-variable [selectedBadge]="selectedBadge"
                                   [style]="'primary'" [text]="'RÉCUP'"
                                   class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
              <div class="table-result-col table-result-col-description">
                Récupération d'amortissement (Perte finale)
              </div>
              <div class="table-result-col table-result-col-dots"></div>
              <div class="table-result-col table-result-col-description text-end">
                <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                     [text]="'FNACC D'"></app-output-variable>
                -
                <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                     [text]="'RÉDUC'"></app-output-variable>
                =
                {{ propertyTransferredOptions.underpreciatedCapitalCostAfterAdditionsAndDispositions | currencyCents | notAvailable }}
                -
                {{ propertyTransferredResults.fNACCReduction | currencyCents | notAvailable }}
                =
              </div>
              <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.recapturedAndTerminalLoss | currencyCents | notAvailable }}</div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</div>